import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const deactivateMarketingSubscription = () => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.DELETE,
    path: `/api/v1/profiles/marketing_subscribes/unsubscribe`,
  });
};

export default deactivateMarketingSubscription;
